<script>
  import { ExternalLinkIcon } from 'vue-feather-icons'

  export default {
    components: {
      ExternalLinkIcon,
    },
    props: {
      method: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        isExporting: false,
      }
    },
    methods: {
      async tryToExport () {
        this.isExporting = true
        await this.method()
        this.isExporting = false
      }
    },
  }
</script>

<template>
  <button class="btn btn-circle btn-export-csv rounded-pill tw-flex align-items-center" v-bind="$attrs" @click="tryToExport">
    <span v-if="!isExporting">EXPORT</span>
    <span v-else>EXPORTING...</span>
    <ExternalLinkIcon size="1x" class="right-icon tw-ml-3 float-right"/>
  </button>
</template>
